const plugin = {
  install (Vue) {
    Vue.mixin({
      mounted () {
        if (this.$el.classList) {
          this.$el.classList.add(`c-${this.$options._componentTag}`)
        }
      }
    })
  }
}

export default plugin



// WEBPACK FOOTER //
// ./~/vue-components/plugins/component-css-class/component-css-class.js